<template>
    <transition name="modal">
        <div>
            <div class="modal-mask">
                <div class="modal-wrapper" @click="$emit('close')">
                    <div class="modal-container" @click.stop="">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content" :class='{isTpg: isTpg}'>
                                <div class="close-modal" @click="$emit('close')">
                                    <font-awesome-icon icon="times" aria-hidden="false" />
                                </div>
                                <div class="header">
                                    Select the document type for <b>{{ documentName }}</b>
                                </div>
                                <div class="doc-type-container">
                                    <div class="doc-type" v-for="doc in docTypes" @click="selectDocType(doc)" :key="doc.name">
                                        {{ doc.name }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import $ from 'jquery';

export default {
  data() {
    return {

    };
  },
  props: ['is-tpg', 'doc-types', 'document-name'],
  methods: {
    cancel() {
      this.$emit('close');
    },
    selectDocType(docType) {
      this.$emit('docTypeSelected', docType);
      this.$emit('close');
    },
  },
  watch: {

  },
  computed: {

  },
};
</script>

<style scoped>
.modal-content {
    background: rgba(72, 70, 77, .9);
    color: white;
}

.modal-content.isTpg {
    background: rgba(72, 70, 77, .9);
}

.doc-type {
    width: 300px;
    background: rgba(100, 100, 100, .9);
    color: white;
    border: 1px solid #666;
    margin: 0 auto;
    border-radius: 5px;
    padding: 8px;
    margin-bottom: 10px;
    cursor: pointer;
}

.doc-type:hover {
    background: rgba(200, 200, 200, .6);
    color: black;
}

.header {
    text-align: center;
    font-size: 18px;
    width: 70%;
    margin: 0 auto;
    margin-bottom: 10px;
    padding: 10px;
    word-wrap: break-word;
}
</style>
